import { render, staticRenderFns } from "./AMSEditForm.vue?vue&type=template&id=1b84eb95&scoped=true&"
import script from "./AMSEditForm.vue?vue&type=script&lang=ts&"
export * from "./AMSEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./AMSEditForm.vue?vue&type=style&index=0&id=1b84eb95&scoped=true&lang=css&"
import style1 from "./AMSEditForm.vue?vue&type=style&index=1&id=1b84eb95&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84eb95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCardText,VContainer,VDatePicker,VMenu,VRadio,VRadioGroup,VSelect,VTextField})
